export type VideoSource = 'CaptureNode' | 'Chime' | 'DirectStream' | 'Livekit' | 'Unknown' | 'Upload' | 'Vera';

export const VIDEO_SOURCE_TYPE_VALUES = Object.freeze({
    CAPTURE_NODE: 'CaptureNode',
    CHIME: 'Chime',
    DIRECT_STREAM: 'DirectStream',
    LIVEKIT: 'Livekit',
    UNKNOWN: 'Unknown',
    UPLOAD: 'Upload',
    VERA: 'Vera',
}) satisfies {[key: string]: VideoSource};
